!(function () {
    "use strict";
    var t = {
            4559: function (t, e, i) {
                i.d(e, {
                    jW: function () {
                        return n;
                    },
                    qF: function () {
                        return r;
                    },
                });
                const n = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const e = window.innerWidth - document.body.offsetWidth,
                        i = document.getElementById("nav-wrapper");
                    t
                        ? (document.body.classList.add("no-scroll"), (document.body.style.paddingRight = e + "px"), (i.style.paddingRight = e + "px"))
                        : (document.body.classList.remove("no-scroll"), (document.body.style.paddingRight = "0px"), (i.style.paddingRight = "0px"));
                };
                document.querySelectorAll(".local-scroll").forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        ((t) => {
                            Math.easeInOutQuad = function (t, e, i, n) {
                                return (t /= n / 2) < 1 ? (i / 2) * t * t + e : (-i / 2) * (--t * (t - 2) - 1) + e;
                            };
                            const e = document.getElementById("grid-archive-header"),
                                i = document.getElementById("nav-wrapper");
                            let n = 0,
                                o = 0;
                            e && (n = e.offsetHeight + 50), i && (o = i.offsetHeight + 50);
                            const r = t.offsetTop - n - o,
                                a = window.scrollY,
                                s = r - a;
                            let c = 0;
                            const d = () => {
                                c += 5;
                                const t = Math.easeInOutQuad(c, a, s, 200);
                                window.scrollTo(0, t), c < 200 && setTimeout(d, 5);
                            };
                            d();
                        })(document.querySelector(e));
                    });
                });
                const o = {};
                function r(t) {
                    document.removeEventListener("focusin", o.focusin), document.removeEventListener("focusout", o.focusout), document.removeEventListener("keydown", o.keydown), t && t.focus();
                }
            },
        },
        e = {};
    function i(n) {
        var o = e[n];
        if (void 0 !== o) return o.exports;
        var r = (e[n] = { exports: {} });
        return t[n](r, r.exports, i), r.exports;
    }
    (i.d = function (t, e) {
        for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
        (i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (function () {
            var t = i(4559);
            document.addEventListener("DOMContentLoaded", function () {
                document.querySelectorAll(".icon").forEach((t) => {
                    t.classList.add("loaded");
                }),
                    document.querySelectorAll('a[target="_blank"]').forEach((t) => {
                        t.innerHTML = t.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>";
                    });
            }),
                void 0 !== window.BOOMR && console.log("Built with " + window.BOOMR.themeName + " (https://themes.shopify.com/themes/align/) version " + window.BOOMR.themeVersion + " by Company XYZ (https://companyxyz.io/)."),
                void 0 === window.Shopify && (window.Shopify = {}),
                (Shopify.bind = function (t, e) {
                    return function () {
                        return t.apply(e, arguments);
                    };
                }),
                (Shopify.setSelectorByValue = function (t, e) {
                    for (var i = 0, n = t.options.length; i < n; i++) {
                        var o = t.options[i];
                        if (e == o.value || e == o.innerHTML) return (t.selectedIndex = i), i;
                    }
                }),
                (Shopify.addListener = function (t, e, i) {
                    t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i);
                }),
                (Shopify.postLink = function (t, e) {
                    var i = (e = e || {}).method || "post",
                        n = e.parameters || {},
                        o = document.createElement("form");
                    for (var r in (o.setAttribute("method", i), o.setAttribute("action", t), n)) {
                        var a = document.createElement("input");
                        a.setAttribute("type", "hidden"), a.setAttribute("name", r), a.setAttribute("value", n[r]), o.appendChild(a);
                    }
                    document.body.appendChild(o), o.submit(), document.body.removeChild(o);
                }),
                (Shopify.CountryProvinceSelector = function (t, e, i) {
                    (this.countryEl = document.getElementById(t)),
                        (this.provinceEl = document.getElementById(e)),
                        (this.provinceContainer = document.getElementById(i.hideElement || e)),
                        Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
                        this.initCountry(),
                        this.initProvince();
                }),
                (Shopify.CountryProvinceSelector.prototype = {
                    initCountry: function () {
                        var t = this.countryEl.getAttribute("data-default");
                        Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
                    },
                    initProvince: function () {
                        var t = this.provinceEl.getAttribute("data-default");
                        t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
                    },
                    countryHandler: function (t) {
                        var e = (o = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                            i = JSON.parse(e);
                        if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
                        else {
                            for (var n = 0; n < i.length; n++) {
                                var o;
                                ((o = document.createElement("option")).value = i[n][0]), (o.innerHTML = i[n][1]), this.provinceEl.appendChild(o);
                            }
                            this.provinceContainer.style.display = "";
                        }
                    },
                    clearOptions: function (t) {
                        for (; t.firstChild; ) t.removeChild(t.firstChild);
                    },
                    setOptions: function (t, e) {
                        var i = 0;
                        for (e.length; i < e.length; i++) {
                            var n = document.createElement("option");
                            (n.value = e[i]), (n.innerHTML = e[i]), t.appendChild(n);
                        }
                    },
                });
            const e = () => {
                var t = [].slice.call(document.querySelectorAll("img"));
                if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
                    let e = new IntersectionObserver(function (t, e) {
                        t.forEach(function (t) {
                            if (t.isIntersecting) {
                                let i = t.target;
                                i.classList.contains("loaded") || (i.classList.add("loaded"), e.unobserve(i));
                            }
                        });
                    });
                    t.forEach(function (t) {
                        e.observe(t);
                    });
                }
            };
            e(),
                document.querySelectorAll("video").forEach((t) => {
                    t.muted = !0;
                    let e = t.play();
                    void 0 !== e &&
                        e.then((e) => {
                            new IntersectionObserver(
                                (e) => {
                                    e.forEach((e) => {
                                        e.isIntersecting || t.paused ? t.paused && t.autoplay && t.play() : t.pause();
                                    });
                                },
                                { threshold: 0 }
                            ).observe(t);
                        });
                });
            const n = function () {
                [].slice.call(document.querySelectorAll("video")).forEach((t) => {
                    const e = t.parentElement.querySelector(".figure--video__poster");
                    e &&
                        e.addEventListener("click", () => {
                            e.classList.add("hidden"), t.play();
                        });
                });
                var t = [].slice.call(document.querySelectorAll(".figure--video-external"));
                if ("IntersectionObserver" in window) {
                    var e = new IntersectionObserver(function (t, e) {
                        t.forEach(function (t) {
                            if (t.isIntersecting)
                                "vimeo" == t.target.dataset.type &&
                                    fetch("http://vimeo.com/api/v2/video/" + t.target.dataset.id + ".json")
                                        .then((t) => {
                                            if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                                            return t.json();
                                        })
                                        .then((e) => {
                                            t.target.querySelector(".figure--video__external-poster-image").src = e[0].thumbnail_large;
                                        }),
                                    t.target.addEventListener("click", function () {
                                        if (!t.target.querySelector("iframe")) {
                                            let t = this.dataset.type,
                                                e = document.createElement("iframe");
                                            e.setAttribute("frameborder", "0"),
                                                e.setAttribute("allowfullscreen", ""),
                                                e.setAttribute("allow", "autoplay"),
                                                "youtube" == t
                                                    ? (e.setAttribute("id", "youtube"), e.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"))
                                                    : e.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"),
                                                this.querySelector(".figure--video__poster").classList.add("hidden"),
                                                this.appendChild(e);
                                        }
                                    });
                            else if (t.target.querySelector("iframe")) {
                                let i = t.target.dataset.type,
                                    n = t.target.querySelectorAll("iframe");
                                if ("youtube" == i) {
                                    var e = { event: "command", func: "pauseVideo" };
                                    n[0].contentWindow.postMessage(JSON.stringify(e), "*");
                                } else "vimeo" == i && ((e = { method: "pause", value: "true" }), n[0].contentWindow.postMessage(JSON.stringify(e), "*"));
                            }
                        });
                    });
                    t.forEach(function (t) {
                        e.observe(t);
                    });
                }
            };
            n(),
                window.addEventListener("beforeprint", () => {
                    const t = document.body.querySelectorAll("details"),
                        e = document.body.querySelectorAll("img");
                    for (let e = 0; e < t.length; e++) t[e].open ? (t[e].dataset.open = "1") : t[e].setAttribute("open", "");
                    for (let t = 0; t < e.length; t++) e[t].dataset.open = "1";
                }),
                window.addEventListener("afterprint", () => {
                    const t = document.body.querySelectorAll("details");
                    for (let e = 0; e < t.length; e++) t[e].dataset.open ? (t[e].dataset.open = "") : t[e].removeAttribute("open");
                }),
                Shopify.designMode &&
                    document.addEventListener("shopify:section:load", () => {
                        n(),
                            document.querySelectorAll(".icon").forEach((t) => {
                                t.classList.add("loaded");
                            }),
                            document.querySelectorAll("img").forEach((t) => {
                                t.classList.add("loaded");
                            });
                    });
            class o extends HTMLElement {
                constructor() {
                    super(), this.addEventListener("change", this.onVariantChange);
                }
                onVariantChange() {
                    this.updateOptions(),
                        this.updateMasterId(),
                        this.currentVariant ? (this.updateMedia(), this.updateURL(), this.renderProductInfo(), this.updateVariantInput(), this.toggleStockStatus(this.currentVariant.available)) : this.setUnavailable();
                }
                updateOptions() {
                    //this.options = Array.from(this.querySelectorAll("select"), (t) => t.value);
                  this.options = Array.from(this.querySelectorAll(".product-converter__dropdown"), (container) => {
  const select = container.querySelector("select");
  if (select) {
    return select.value;
  }

  const checkedRadio = container.querySelector('input[type="radio"]:checked');
  return checkedRadio ? checkedRadio.value : null;
});
console.log(this.options)
                }
                updateMasterId() {
                    this.currentVariant = this.getVariantData().find((t) => !t.options.map((t, e) => this.options[e] === t).includes(!1));
                }
                updateMedia() {
                    if (!this.currentVariant) return;
                    if (!this.currentVariant.featured_media) return;
                    const t = document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section} .swiper-wrapper`);
                    if (this.currentVariant.featured_media) {
                        const e = this.currentVariant.featured_media.id;
                        document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper
                            ? document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper &&
                              document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slides.forEach((t) => {
                                  if (!t.classList.contains("swiper-slide-duplicate")) {
                                      const i = t.getAttribute("data-id"),
                                          n = t.getAttribute("data-swiper-slide-index");
                                      e == i && document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slideToLoop(n);
                                  }
                              })
                            : t.prepend(t.querySelector('[data-id="' + e + '"]')),
                            document.querySelector(".sticky-add-to-cart__image") && (document.querySelector(".sticky-add-to-cart__image").src = this.currentVariant.featured_media.preview_image.src);
                    }
                }
                updateURL() {
                    this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
                }
                updateVariantInput() {
                    document.querySelectorAll(`#form-product-${this.dataset.section}, #form-product-installment-${this.dataset.section}`).forEach((t) => {
                        const e = t.querySelector('input[name="id"]');
                        (e.value = this.currentVariant.id), e.dispatchEvent(new Event("change", { bubbles: !0 }));
                    })
                      if (document.querySelector(".product-converter")) {
  document.querySelectorAll("variant-selects").forEach((t) => {
    const options = [this.currentVariant.option1, this.currentVariant.option2, this.currentVariant.option3];

    options.forEach((optionValue, index) => {
      if (!optionValue) return;

      const select = t.querySelectorAll("select")[index];
      if (select) {
        select.value = optionValue;
       // select.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change if needed
      } else {
        // Handle radio buttons
        const radios = t.querySelectorAll(`input[type="radio"][name="options[${select?.name || ''}]"]`);
        radios.forEach((radio) => {
          if (radio.value === optionValue) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change if needed
          }
        });
      }
    });
  });
}

                        /*document.querySelector(".product-converter") &&
                            document.querySelectorAll("variant-selects").forEach((t) => {
                                this.currentVariant.option1 && (t.querySelectorAll("select")[0].value = this.currentVariant.option1),
                                    this.currentVariant.option2 && (t.querySelectorAll("select")[1].value = this.currentVariant.option2),
                                    this.currentVariant.option3 && (t.querySelectorAll("select")[2].value = this.currentVariant.option3);
                            });*/
                }
                renderProductInfo() {
                    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
                        .then((t) => t.text())
                        .then((i) => {
                            const n = new DOMParser().parseFromString(i, "text/html"),
                                o = document.getElementById(`price-${this.dataset.section}`),
                                r = n.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                                a = document.getElementById(`sticky-price-${this.dataset.section}`),
                                s = n.getElementById(`sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                                c = document.getElementById(`pickup-availability-${this.dataset.section}`),
                                d = n.getElementById(`pickup-availability-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                                l = document.getElementById(`pickup-availability-modal-${this.dataset.section}`),
                                u = n.getElementById(`pickup-availability-modal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                            r && o ? (o.classList.remove("u-invisible"), (o.innerHTML = r.innerHTML)) : o.classList.add("u-invisible"),
                                s && a ? (a.classList.remove("u-invisible"), (a.innerHTML = s.innerHTML)) : a && a.classList.add("u-invisible"),
                                d && c && (c.innerHTML = d.innerHTML),
                                u && l && (l.innerHTML = u.innerHTML);
                            const p = document.querySelector(".pickup-availability"),
                                h = document.getElementById("overlay"),
                                y = document.getElementById("pickup-availability-open"),
                                m = document.getElementById("pickup-availability-close");
                            y &&
                                document.getElementById("pickup-availability-open").addEventListener("click", function () {
                                    p.classList.add("open"), h.classList.add("open"), document.body.classList.add("active", "minicart"), (0, t.jW)(!0), e();
                                }),
                                m &&
                                    document.getElementById("pickup-availability-close").addEventListener("click", function () {
                                        p.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, t.jW)(!1), overlay.classList.remove("open", "overlay--all"), (0, t.qF)(p);
                                    });
                        });
                }
                toggleStockStatus(t) {
                    const e = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                        i = document.getElementById(`stock-status-${this.dataset.section}`);
                    i && i.classList.remove("u-invisible"),
                        e &&
                            (t
                                ? (e.forEach((t) => {
                                      const e = t.querySelector('[name="add"]'),
                                          i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                                      e && (e.removeAttribute("disabled"), (i.textContent = "Add to cart"));
                                  }),
                                  i && i.classList.add("in-stock"))
                                : (e.forEach((t) => {
                                      const e = t.querySelector('[name="add"]'),
                                          i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                                      e && (e.setAttribute("disabled", "disabled"), (i.textContent = "Sold out"));
                                  }),
                                  i && i.classList.remove("in-stock")));
                }
                setUnavailable() {
                    const t = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                        e = document.getElementById(`stock-status-${this.dataset.section}`);
                    t.forEach((t) => {
                        const i = t.querySelector('[name="add"]'),
                            n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        i && ((n.textContent = window.cartStrings.unavailable), i.setAttribute("disabled", "disabled"), e && e.classList.add("u-invisible"));
                    });
                    const i = document.getElementById(`price-${this.dataset.section}`),
                        n = document.getElementById(`sticky-price-${this.dataset.section}`);
                    i && i.classList.add("u-invisible"), n && n.classList.add("u-invisible");
                }
                getVariantData() {
                    return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
                }
            }
            customElements.define("variant-selects", o);
        })();
})();
